import { usePartnerDashboardContext } from "../partner-dashboard/usePartnerDashboardContext";
import { partnerAddressInfo } from "../form/partner-edit-contants";
import { GenericInfoField } from "../../../../common/helpers/generic-info-field";

export function PartnerAddress() {
  const { partner } = usePartnerDashboardContext()
  const setPartnerAddressInfo = partnerAddressInfo(partner)

  return (
    <div className="tabs-border-line">
      <section className="tabs-item-style">
        <h2 className="text-2xl font-semibold mb-4">Endereço</h2>
        <div className="grid grid-cols-3 gap-2 mb-4">
          {setPartnerAddressInfo.map((info) => {
            return (<GenericInfoField id={info.id} spanSize={info.spanSize} label={info.label} value={info.value} />)
          })}
        </div>
      </section>
    </div>
  );
}